module.exports = __webpack_public_path__ + "img/sybg.01bccd72.png";